import reducer from "./reducers";

import * as actividadesOps from "./operations";
import * as actividadesTypes from "./types";

export { actividadesOps, actividadesTypes };

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/actividades/index.js